import React from 'react';
import Card from './Card';

export default function Statistics({ statistics }) {
  return (
    <div className="python-stats-container">
      <svg
        width="256"
        height="285"
        viewBox="0 0 256 285"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <rect
          opacity="0.75"
          x="137"
          y="174"
          width="111"
          height="111"
          rx="50"
          fill="#2C78F6"
          fillOpacity="0.5"
        />
        <rect
          opacity="0.75"
          width="164"
          height="164"
          rx="30"
          fill="#2C78F6"
          fillOpacity="0.2"
        />
        <rect
          opacity="0.75"
          x="71"
          y="45"
          width="185"
          height="185"
          rx="50"
          fill="#2C78F6"
          fillOpacity="0.4"
        />
      </svg>

      <div className="python-stats-card-wrapper">
        {statistics.map((stat) => (
          <Card key={stat.title} cardDetails={stat} />
        ))}
      </div>

      <svg
        width="256"
        height="285"
        viewBox="0 0 256 285"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <rect
          opacity="0.75"
          x="137"
          y="174"
          width="111"
          height="111"
          rx="50"
          fill="#2C78F6"
          fillOpacity="0.5"
        />
        <rect
          opacity="0.75"
          width="164"
          height="164"
          rx="30"
          fill="#2C78F6"
          fillOpacity="0.2"
        />
        <rect
          opacity="0.75"
          x="71"
          y="45"
          width="185"
          height="185"
          rx="50"
          fill="#2C78F6"
          fillOpacity="0.4"
        />
      </svg>
    </div>
  );
}
